import React from 'react';
import { ComingSoonPage } from '@components/ui/pages';
import { Typography } from '@mui/material';
import { useEventTracking } from '@services/statsig';

import { useTracking } from '../../../context/TrackingContext';
import { EventType } from '../../../types/events';

/**
 * PatientCommunicationsPage Component
 *
 * A "coming soon" page for the Patient Communications feature.
 * Displays information about the upcoming communications feature
 * with a CTA for expressing interest.
 */
export const PatientCommunicationsPage: React.FC = () => {
  const { communications } = useEventTracking();
  const { trackEvent } = useTracking();

  const handleInterestedClick = () => {
    communications.interestedClicked();
    trackEvent(EventType.EXPRESSED_INTEREST, {
      feature: 'communications',
    });
  };

  return (
    <ComingSoonPage
      title="Patient Communications"
      showHeader={false}
      heroTitle="Patient Communications"
      description={
        <Typography component="span" sx={{ fontStyle: 'italic' }}>
          Coming soon
        </Typography>
      }
      primaryAction={{
        label: "I'm Interested",
        onClick: handleInterestedClick,
      }}
    />
  );
};

